import { useContext, useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { setEmptyMessage } from "../Store/reducers/notifySlice";
// import { MdOutlineCancel } from "react-icons/md";
import { TfiClose } from "react-icons/tfi";
import SearchContext from "../components/context/SearchContext";


const notifySuccess = (message) =>
  toast.success(message, {
    position: "top-center",
    autoClose: 3000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
  });

const notifyError = (message = "Internal Server Error") =>
  toast.error(message, {
    position: "top-center",
    autoClose: 3000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
  });

const NotifyAlert = ({ message }) => {
  const [toggleMsg, setToggleMsg] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const searchState = useContext(SearchContext);
  const { HandleCart } = searchState || {};

  useEffect(() => {
    let count = 0;

    const intervalId = setInterval(() => {
      setToggleMsg(true);
      count += 1;
      if (count > 3) {
        clearInterval(intervalId);
        setToggleMsg(false);
        dispatch(setEmptyMessage(""));
      }
    }, 1000);

    return () => clearInterval(intervalId);
  }, []); // Empty dependency array to run the effect only once on component mount


  const handleAlertClick = () => {
    if (message === "Item Added To Cart !!") {
      navigate("/cart");
      dispatch(setEmptyMessage(""));
    }
  };

  return (
    <div 
      className={`w-full bg-[#A03907] py-2 flex items-center justify-center text-white ${!toggleMsg && 'hidden'} fixed top-0 left-0 z-[999999999] ${message === "Item Added To Cart !!" ? 'cursor-pointer hover:bg-[#8a3106] transition-colors' : ''}`}
      onClick={handleAlertClick}
    >
      <span className={`w-[90%] flex items-center justify-center transition-all duration-300 ease-in-out`}>
        {message} </span>
      <span className="cursor-pointer absolute top-0 right-[20px] flex items-center justify-center h-10"
        onClick={(e) => { 
          e.stopPropagation();
          setToggleMsg(false); 
          dispatch(setEmptyMessage(""));
        }}
      >
        <TfiClose className="w-4 h-4" />
      </span>
    </div>
  );
}

export default NotifyAlert;


export { notifySuccess, notifyError };